import React from 'react';
import { AppState } from 'core/redux/reducers';
import { selectTranslator, TransFn } from 'core/redux/features/languages/trans';
import { connect } from 'react-redux';
import {
  BookingStep1,
  BookingStep2,
  IBookingOrder,
} from 'core/redux/features/booking/types';
import { selectActiveProduct } from 'core/redux/features/products/reducers/products';
import { TimeUtil } from 'core/utils/date';
import { selectBookingStepData } from 'core/redux/features/booking/reducers';
// import { hot } from 'react-hot-loader/root'
import {
  BOOKING_STEP1,
  BOOKING_STEP2,
} from 'core/redux/features/booking/constants';
import CheckoutSummary from 'Components/Checkout/CheckoutSummary';

const mapStateToProps = (state: AppState) => ({
  step1: selectBookingStepData(state, BOOKING_STEP1) as BookingStep1,
  step2: selectBookingStepData(state, BOOKING_STEP2) as BookingStep2,
  order: state.booking.order,
  loading: state.booking.loading,
  productMenus: state.products.entities.menus,
  trans: selectTranslator(state),
  product: selectActiveProduct(state),
  local: state.local,
});

const mapDispatchToProps = {};

interface IProps {}

type TProps = IProps &
  ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps;

function GiftCardRemainingValueNotice({
  order,
  trans,
  email,
}: {
  order: IBookingOrder;
  trans: TransFn;
  email: string;
}) {
  if (order.giftcards.length === 0 || order.total > 0) {
    return null;
  }

  const totalAmount = parseInt(
    // @ts-ignore
    order.line_items.find(item => item.type === 'total_amount')?.amount || 0,
  );

  console.log(order.giftcards);
  const gitcards = Object.values(order.giftcards)
    .filter(g => g.type !== 'percentage')
    .sort((a, b) => parseInt(a.value) - parseInt(b.value));

  const gcSum = gitcards.reduce((a, b) => a + parseInt(b.value), 0);

  if (totalAmount > gcSum) {
    return null;
  }
  const remainingGC = gcSum - totalAmount;
  if (remainingGC < 1) {
    return null;
  }
  return (
    <div className="sukli">
      {trans('remaining_gc_notice', { value: remainingGC, email: email })}
    </div>
  );
}

function SummaryComp(props: TProps) {
  const { product, trans, step1, step2, productMenus, order, loading, local } =
    props;
  const menus = Object.values(step1.data.menus);

  let timeLabel;

  if (step1.data.time === '0') {
    timeLabel = '-- ';
  } else {
    timeLabel = new TimeUtil(step1.data.time).format('HH.MM ');
  }

  if (step1.data.time_end) {
    timeLabel += ' - ' + TimeUtil.parse(step1.data.time_end).format('HH.MM ');
  }

  return (
    <>
      <CheckoutSummary
        showLineItems={order.line_items.length > 0}
        showLineItemsLoading={
          loading &&
          step1.data.num_person > 0 &&
          Object.values(step1.data.menus).length > 0 &&
          step1.data.time !== '0'
        }
        order={order}
        title={product?.name ?? ''}
      >
        <p>
          <span>
            {step1.data.num_person}{' '}
            {step1.data.num_person > 1 ? trans('persons') : trans('person')}
          </span>
          <br />
          <span>
            {local === window.__defaultLocale__ && 'KL. '}
            {timeLabel}
            <span className="has-text-weight-bold">{trans('time_suffix')}</span>
          </span>
        </p>
        <p className="book-summary__menus">
          {menus.map(({ menu_id, num_person }) => {
            if (num_person < 1) {
              return null;
            }

            return (
              <span className="book-summary__menus__menu" key={menu_id}>
                {num_person} X {productMenus[menu_id].name}
              </span>
            );
          })}
        </p>
      </CheckoutSummary>
      <div style={{ marginTop: 20 }}>
        <GiftCardRemainingValueNotice
          email={step2.data.email}
          trans={trans}
          order={order}
        />
      </div>
    </>
  );
}

// const StepsRoot =./src/Features/Booking/Steps/index.tsx
//   process.env.NODE_ENV !== 'production' ? hot(SummaryComp) : SummaryComp;
export default connect(mapStateToProps, mapDispatchToProps)(SummaryComp);
